import {
  BORRAR_EXCEL_PEDIDO,
  CAMBIAR_CANTIDAD_ARTICULO,
  IMPORTAR_EXCEL_PEDIDO,
  IMPORTAR_EXCEL_PEDIDO_FAILURE,
  IMPORTAR_EXCEL_PEDIDO_SUCCESS,
} from '../actions/types.js'

const initialState = {
  isLoading: false,
  lineasExcel: [],
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case IMPORTAR_EXCEL_PEDIDO:
      return {
        ...state,
        isLoading: true,
      }
    case IMPORTAR_EXCEL_PEDIDO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        lineasExcel: action.payload,
      }
    case IMPORTAR_EXCEL_PEDIDO_FAILURE:
      return {
        ...state,
        isLoading: false,
      }
    case CAMBIAR_CANTIDAD_ARTICULO:
      let lineas = state.lineasExcel
      let indiceModificacion = lineas.findIndex(l => l.rowNum === action.payload.rowNum)
      lineas[indiceModificacion] = action.payload
      return {
        ...state,
        lineasExcel: state.lineasExcel.map(linea =>
          linea.rowNum === action.payload.rowNum ? { ...linea, ...action.payload } : linea,
        ),
      }
    case BORRAR_EXCEL_PEDIDO:
      return {
        isLoading: false,
        lineasExcel: [],
      }
    default:
      return state
  }
}
